import React, { useEffect, useState } from "react";
import {
  handleSpringDataMutationRequest,
  handleSpringDataRequest,
} from "../../api/index";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import { getAllStaffsData } from "./HouseKeepingApi";
import { toast } from "material-react-toastify";
import "material-react-toastify/dist/ReactToastify.css";
import { connect } from "react-redux";
import DashboardMockLoader from "../../Utils/DashboardMockLoader";
import { getAllNonHiddenRoomTypes } from "../InventoryCalendar/api/InventoryApi";
import {
  Button,
  Stack,
  Typography,
  CircularProgress,
  Tooltip,
  IconButton,
} from "@mui/material";
import { OutlinedButton } from "../../Utils/ButtonHelper";
import InfoIcon from "@mui/icons-material/Info";
import { useTranslation } from "react-i18next";
import i18n from "../../modules/Auth/pages/i18n";

function StaffAssignment(props) {
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(props.selectedLanguage);
  }, [props.selectedLanguage]);
  const hotelId = props.data.hotelId;

  /* CURRENT DETAILS */
  // Staff details
  const [staffVal, setStaffVal] = useState({
    selectedStaffName: "",
    selectedStaffId: "",
  });

  // Room type details
  const [roomTypeVal, setRoomTypeVal] = useState({
    selectedRoomTypeName: "",
    selectedRoomTypeId: "",
  });

  /* HOUSEKEEPING STAFF DETAILS */
  const [staffData, setStaffData] = useState([]);
  const getAllData = async () => {
    try {
      const data = await getAllStaffsData();
      setStaffData(data);
      setStaffVal({
        selectedStaffName: data[0]?.email,
        selectedStaffId: data[0]?.email,
      });
      console.log(data);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(async () => {
    await getAllData();
  }, []);

  const [loader, setloader] = useState(false);

  /* GET ALL THE ROOM TYPES */

  const [rooms, setRooms] = useState(null);

  const getAllRooms = async () => {
    try {
      const data = await getAllNonHiddenRoomTypes();
      let tempRooms = [];
      for (const [key, value] of Object.entries(data)) {
        tempRooms.push({ text: value, id: key });
      }
      setRooms(tempRooms);
      setRoomTypeVal({
        // ...roomTypeVal,
        selectedRoomTypeName: Object.values(data)[0],
        selectedRoomTypeId: Object.keys(data)[0],
      });
      getAllRoomDetails(Object.keys(data)[0]);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(async () => {
    await getAllRooms();
  }, []);

  /* ROOM RELATED DETAILS USING THE ROOM TYPE ID */
  // Get all the room details for the particular room ID
  const [data, setData] = useState([]);
  const getAllRoomDetails = (id) => {
    handleSpringDataRequest(
      `core/api/v1/hk/get-room-ids?forCharter=false&${hotelId}&roomTypeId=${id}`
    ).then((res) => {
      setloader(true);
      setData(res);
      setloader(false);
    });
  };

  useEffect(() => {
    getAllRoomDetails(roomTypeVal.selectedRoomTypeId);
  }, [roomTypeVal.selectedRoomTypeId]);

  // Get all the selected room ids
  const [selectedRooms, setSelectedRooms] = useState([]);
  const [unAssignedRooms,setUnAssignedRooms]=useState([]);
  const handleSelectedRooms = (id) => {
    if (selectedRooms.indexOf(id) !== -1) {
      const data = selectedRooms.filter((room) => String(room) !== String(id));
      setSelectedRooms(data);
    
      // Add the room to unassignedRooms when it's deselected
    setUnAssignedRooms([...unAssignedRooms, id]);
   
    } 
    else if (unAssignedRooms.includes(id)) {
      // If room is in unassignedRooms, remove it from there
      setUnAssignedRooms(unAssignedRooms.filter((room) => room !== id));
     
    } 
    else {

     setSelectedRooms([...selectedRooms, id]);
   
    }
  };

  useEffect(()=>{
    console.log(unAssignedRooms);
  },[unAssignedRooms]);

  useEffect(() => {
    const tempSelectedRooms = data?.filter(
      (item) =>
        item?.hkStaffList &&
        item?.hkStaffList.includes(
          staffVal.selectedStaffName.length === 0
            ? staffData[0]?.email
            : staffVal.selectedStaffName
        )
    );

    const arr = tempSelectedRooms.map((room) => room.roomId);

    return setSelectedRooms(tempSelectedRooms.map((room) => room.roomId));
  }, [data, staffVal.selectedStaffId]);

  // assigning rooms to staff
  function assignRoom(roomId) {
    if (selectedRooms?.length <= 0) {
      toast.error(`${t("Please select room ID's to assign")}`);
      return;
    }

    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/hk/assign-rooms-to-staff`,
      {
        roomIds: selectedRooms,
        roomTypeId:
          roomTypeVal.selectedRoomTypeId.length > 0
            ? roomTypeVal.selectedRoomTypeId
            : rooms && rooms[0]?.id,
        staffId:
          staffVal.selectedStaffId.length > 0
            ? staffVal.selectedStaffId
            : staffData[0]?.email,
        staffName:
          staffVal.selectedStaffId.length > 0
            ? staffVal.selectedStaffId
            : staffData[0]?.email,
      }
    )
      .then((res) => setRooms(null))
      .then((res) => getAllRooms())
      .then((res) => toast.success(`${t("Assigned Successfully")}`))
      .catch((err) => console.log(err));
  }


function unAssignRooms(roomId) {
    if (unAssignedRooms?.length <= 0) {
      toast.error(`${t("Please select room ID's to unAssign")}`);
      return;
    }

    handleSpringDataMutationRequest(
      "POST",
      `core/api/v1/hk/unassign-rooms-to-staff`,
      {
        roomIds: unAssignedRooms,
        roomTypeId:
          roomTypeVal.selectedRoomTypeId.length > 0
            ? roomTypeVal.selectedRoomTypeId
            : rooms && rooms[0]?.id,
        staffId:
          staffVal.selectedStaffId.length > 0
            ? staffVal.selectedStaffId
            : staffData[0]?.email,
        staffName:
          staffVal.selectedStaffId.length > 0
            ? staffVal.selectedStaffId
            : staffData[0]?.email,
      }
    )
    .then((res) => {
      setRooms(null);
      setUnAssignedRooms([]);  // Clear unAssignedRooms after successful call
    })
      .then((res) => getAllRooms())
      .then((res) => toast.success(`${t("Unassigned Successfully")}`))
      .catch((err) => console.log(err));
  }







  return loader === false ? (
    <>
      <h3 style={{ marginLeft: "1rem" }}>
        {t(
          "This page is used when the admin wants to assign/unassign a room number to the housekeeping staff forever. If any staff is not assigned in future for that particular room when a room is dirty then the staff who is assigned from here will automatically be allocated to that room."
        )}
      </h3>
      <div className="staffAssignmentWrapper">
        <div className="searchFiltersWrapper">
          <div className="staffFiltersWrapper">
            {/* displaying the staff list and updating the same */}
            <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
              <InputLabel id="demo-simple-select-autowidth-label">
                {t("Select user")}
              </InputLabel>
              <Select
                value={staffVal.selectedStaffName}
                onChange={(e, val) =>
                  setStaffVal({
                    selectedStaffName: val.props.name,
                    selectedStaffId: e.target.value,
                  })
                }
                id="controllable-states-demo"
                labelId="demo-simple-select-autowidth-label"
                sx={{ width: 250 }}
                input={<OutlinedInput label={t("Select user")} />}
              >
                {staffData.map((item, index) => (
                  <MenuItem key={index} name={item.email} value={item.email}>
                    {item.email}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          {/* room types filters */}
          <div className="roomTypeFilters">
            <FormControl
              sx={{
                m: 1,
                minWidth: 120,
              }}
              size="small"
            >
              <InputLabel id="demo-simple-select-autowidth-label">
                {t("Select Room Type")}
              </InputLabel>
              <Select
                value={
                  roomTypeVal.selectedRoomTypeId.length === 0
                    ? rooms && rooms[0]?.id
                    : roomTypeVal.selectedRoomTypeId
                }
                onChange={(e, val) =>
                  setRoomTypeVal({
                    // ...roomTypeVal,
                    selectedRoomTypeName: val.props.name,
                    selectedRoomTypeId: e.target.value,
                  })
                }
                id="controllable-states-demo"
                labelId="demo-simple-select-autowidth-label"
                sx={{ width: 250 }}
                // autoWidth
                label={t("Select Room Type")}
              >
                {rooms &&
                  rooms.map((item, index) => {
                    return (
                      <MenuItem key={index} name={item.text} value={item.id}>
                        {item.text}
                      </MenuItem>
                    );
                  })}
              </Select>
            </FormControl>
          </div>

          <div className="assignUpdateButton">
            <OutlinedButton
              text={t("Assign")}
              onClick={() => assignRoom()}
              height="35px"
            />
            
          </div>
          <div className="assignUpdateButton">
            <OutlinedButton
              text={t("Unassign")}
              onClick={() => unAssignRooms()}
              height="35px"
            />
            
          </div>
        </div>
        {/* displaying the room data */}
        <>
          <Typography className="mt-4 ml-2" style={{ fontSize: "17.5px" }}>
            {t("Number of rooms assigned to")}{" "}
            <b> {staffVal.selectedStaffName} </b> -{" "}
            <b>{selectedRooms.length}</b>
          </Typography>
          {data.length > 0 ? (
            <div className="staffTableWrapper">
              <Stack
                direction={"row"}
                className="position-relative w-100 d-flex justify-content-start"
                // spacing={1}
                style={{
                  flexWrap: "wrap",
                }}
              >
                {data.map((item) => (
                  <Stack className="mr-2 mb-2">
                    {selectedRooms.indexOf(item.roomId) !== -1 ? (
                      <Button
                        key={item.roomId}
                        variant="custom-button"
                        style={{ height: "37.5px" }}
                        onClick={() => handleSelectedRooms(item.roomId)}
                      >
                        {" "}
                        {item.roomId}{" "}
                      </Button>
                    ) 
                    : unAssignedRooms.includes(item.roomId) ? (
                      <Button
                        variant="contained"
                        style={{ height: "37.5px", backgroundColor: "red" }} // Red for unassigned
                        onClick={() => handleSelectedRooms(item.roomId)}
                      >
                        {item.roomId}
                      </Button>
                      ): (
                      <OutlinedButton
                        key={item.roomId}
                        text={item.roomId}
                        height="37.5px"
                        onClick={() => handleSelectedRooms(item.roomId)}
                      />
                    )}
                  </Stack>
                ))}
              </Stack>
            </div>
          ) : (
            <Stack
              direction="row"
              className="mt-5 ml-4 d-flex justify-content-center align-items-center"
              spacing={2}
            >
              <Typography style={{ marginTop: "auto", marginBottom: "auto" }}>
                {t("Loading...")}
              </Typography>
              <Typography style={{ marginTop: "auto", marginBottom: "auto" }}>
                <CircularProgress size="17.5px" />
              </Typography>
            </Stack>
          )}
        </>
      </div>
    </>
  ) : (
    <DashboardMockLoader />
  );
}

function mapStateToProps(state) {
  return { data: state.auth.selectedHotel };
}
export default connect(mapStateToProps)(StaffAssignment);
